var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0h8v4H8z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2h-3v3a1.003 1.003 0 0 1-1 1H7a1.003 1.003 0 0 1-1-1V2H3a1.003 1.003 0 0 0-1 1v20a1.003 1.003 0 0 0 1 1h18a1.003 1.003 0 0 0 1-1V3a1.003 1.003 0 0 0-1-1m-6 20H6a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2M5 18a1.003 1.003 0 0 1 1-1h5a1 1 0 0 1 0 2H6a1.003 1.003 0 0 1-1-1m10-2H6a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2M5 12a1.003 1.003 0 0 1 1-1h5a1 1 0 0 1 0 2H6a1.003 1.003 0 0 1-1-1m13-2H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClipboard);
export default __webpack_public_path__ + "static/media/new-clipboard.f0a42cb6a6b5528eb99637775eb0408b.svg";
export { ForwardRef as ReactComponent };